// components/shared/TheMission.jsx
import React from "react";

const TheMission = () => {
    return (
        <div className="min-h-screen bg-darkblue text-lightgray px-6 py-16">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl text-orange text-center mb-12">
                    Our Mission
                </h1>

                <div className="space-y-12">
                    {/* Employers Section */}
                    <section>
                        <h2 className="text-2xl font-bold text-orange mb-4">
                            For Employers
                        </h2>
                        <p className="mb-4 text-lg">
                            No employer should have to settle for just a warm body. Traditional resumes rarely capture the true essence of a person, and job descriptions often miss the spirit of the role. There’s someone out there who will not only embrace your vision but also excel under your leadership—exactly the talent your business deserves.
                        </p>
                        <p className="mb-4 text-lg">
                            At CareerMission, we go beyond paper. We connect the human behind the resume with the perfect candidate for your opening, transforming outdated practices into genuine connections.
                        </p>
                    </section>

                    {/* Job Seekers Section */}
                    <section>
                        <h2 className="text-2xl font-bold text-orange mb-4">
                            For Job Seekers
                        </h2>
                        <p className="mb-4 text-lg">
                            It’s not just about landing any job—it’s about finding that role and manager who are looking for someone exactly like you. After all, when you love what you do, you’ll never work a day in your life.
                        </p>
                    </section>

                    {/* Call to Action */}
                    <section className="text-center">
                        <p className="text-xl font-bold text-orange mb-2">
                            Join the mission.
                        </p>
                        <p className="text-lg">
                            For every opening, a perfect candidate. For every candidate, a dream job.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TheMission;
